import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useModalStore = defineStore('modal', () => {
  const activeModal = ref(null)
  const modalProps = ref({})
  const modalOptions = ref({
    backdropClosable: true,
  })

  let resolver = null
  let rejecter = null

  function openModal(name, props = {}, options = {}) {
    activeModal.value = name
    modalProps.value = props
    modalOptions.value = {
      backdropClosable: true,
      ...options
    }

    return new Promise((resolve, reject) => {
      resolver = resolve
      rejecter = reject
    })
  }

  function resolveModal(data) {
    resolver?.(data)
    resetModal()
  }

  function rejectModal(reason) {
    rejecter?.(reason)
    resetModal()
  }

  function resetModal() {
    activeModal.value = null
    modalProps.value = {}
    modalOptions.value = { backdropClosable: true }
    resolver = null
    rejecter = null
  }

  return {
    activeModal,
    modalProps,
    modalOptions,
    openModal,
    resolveModal,
    rejectModal,
  }
})
